import { getAnalytics, logEvent } from "firebase/analytics";
import { FirebaseApp, getApp, getApps, initializeApp } from "firebase/app";

import log from "logbeacon";
import {
  fetchAndActivate,
  getRemoteConfig,
  RemoteConfig,
  getValue as getFirebaseValue,
} from "firebase/remote-config";
import { config } from "@/src/config";

const firebaseConfig = config?.firebaseConfig;

const getFirebaseApp = () => {
  return getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
};

const genRemoteConfig = () => {
  let remoteConfig: RemoteConfig;

  return (app?: FirebaseApp) => {
    if (remoteConfig) {
      return remoteConfig;
    }
    remoteConfig = getRemoteConfig(app);
    return remoteConfig;
  };
};

const getFirebaseConfig = genRemoteConfig();
const fireBaseApp = getFirebaseApp();

export const initFirebaseRemoteConfig = async () => {
  const app = getFirebaseApp();
  const remoteConfig = getFirebaseConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 1;
  remoteConfig.defaultConfig = {};
  await fetchAndActivate(remoteConfig);
};

export const getValue = async (key: string) => {
  const remoteConfig = getFirebaseConfig();
  await fetchAndActivate(remoteConfig);

  return getFirebaseValue(remoteConfig, key);
};

export function logEventAnalytics(
  eventName: string,
  params?: { [key: string]: any },
) {
  const analytics = getAnalytics(fireBaseApp);

  try {
    // 处理params，将对象转换为字符串
    const processedParams = params ? processAnalyticsParams(params) : undefined;
    log.debug(`[文案]edgen_${eventName}`, processedParams);
    return logEvent(analytics, `edgen_${eventName}`, processedParams);
  } catch (e: any) {
    log.error(`[文案]--logEventAnalytics--${e?.message}`);
  }
}

// 递归处理参数，将对象转换为JSON字符串
function processAnalyticsParams(params: { [key: string]: any }): {
  [key: string]: any;
} {
  const result: { [key: string]: any } = {};

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = params[key];

      if (value === null) {
        result[key] = "null";
      } else if (value === undefined) {
        // 跳过undefined值
        continue;
      } else if (typeof value === "object" && !Array.isArray(value)) {
        // 对象转为JSON字符串
        try {
          result[key] = JSON.stringify(value);
        } catch (error) {
          result[key] = "[Object cannot be serialized]";
          log.warn(
            `[文案]Analytics object serialization failed: ${key}`,
            error,
          );
        }
      } else if (Array.isArray(value)) {
        // 数组也转为字符串
        try {
          result[key] = JSON.stringify(value);
        } catch (error) {
          result[key] = "[Array cannot be serialized]";
          log.warn(`[文案]Analytics array serialization failed: ${key}`, error);
        }
      } else {
        // 原始类型直接保留
        result[key] = value;
      }
    }
  }

  return result;
}
